export default __webpack_public_path__ + "static/media/payment-success.7e03a517.svg";